module.exports = __webpack_public_path__ + "img/14.84dae4cd.jpg";